import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-table-card-footer',
  templateUrl: 'table-card-footer.component.html',
  styleUrls: ['table-card-footer.component.scss']
})
export class TableCardFooterComponent {
}
